import BillingOrderNewEditStepsForm from '@/sections/management/accounts/billing-orders/components/form/billing-order-new-edit-steps-form';

import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

export default function BillingOrderCreatePage() {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('New Billing Order')} | Orion</title>
      </Helmet>

      <BillingOrderNewEditStepsForm />
    </>
  );
}
